import React, { useEffect, useMemo, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import Table from '../../../../../components/Table'
import { DeleteVideoApi } from '../services/deleteVideoApi'
import { GetVideoListApi } from '../services/getVideoListApi'
import { IVideo } from '../models/responseModels'

function ListVideo(props: BaseComponentWithContextProps) {
  const navigate: any = useNavigate()
  const [videos, setVideos] = useState<IVideo[]>([])

  useEffect(() => {
    getVideos()
  }, [])

  const getVideos = async () => {
    props.showLoading()
    const api = new GetVideoListApi({})
    api.getVideos().then(res => {
      setVideos(res)
      props.hideLoading()
    })
  }

  const deleteVideo = async (id: number) => {
    Swal.fire({
      icon: 'question',
      title: 'Videoyu silmek istediğinize emin misiniz?',
      showConfirmButton: true,
      allowOutsideClick: false,
      showDenyButton: true,
      confirmButtonText: 'Evet',
      denyButtonText: 'Hayır',
    }).then(async result => {
      if (result.isConfirmed) {
        const api = new DeleteVideoApi({})
        api
          .deleteVideo(id)
          .then(() => {
            Swal.fire({
              icon: 'success',
              title: 'Video Silindi',
              showConfirmButton: true,
              allowOutsideClick: false,
            }).then(() => setVideos(videos.filter(x => x.Id !== id)))
          })
          .catch((err: any) => {
            Swal.fire({
              icon: 'error',
              title: err.description,
              showConfirmButton: true,
              allowOutsideClick: false,
            })
          })
      }
    })
  }

  const tableColumns = useMemo(
    () => [
      { Header: '#', accessor: 'col1' },
      { Header: 'Kategori', accessor: 'category' },
      { Header: 'Başlık', accessor: 'title' },
      { Header: 'Kaynak', accessor: 'source' },
      { Header: 'Sıra', accessor: 'order' },
      { Header: 'Durum', accessor: 'status' },
      { Header: 'İşlemler', accessor: 'actions' },
    ],
    []
  )

  const tableData = useMemo(
    () =>
      videos.map((item, index) => ({
        col1: index + 1,
        category: item.VideoCategoryName,
        title: item.Title,
        source: item.SourceType === 1 ? 'Link' : 'Dosya',
        order: item.OrderNo,
        status: item.Active ? 'Aktif' : 'Pasif',
        actions: (
          <div>
            <a
              role='button'
              style={{ cursor: 'pointer' }}
              title='Düzenle'
              onClick={() => navigate('/admin/HomeAndSiteOperation/video/add', { state: { data: item, flag: 'update' } })}
            >
              <i className='icon-edit' style={{ fontSize: '1.2rem', color: 'green' }}></i>
            </a>
            &nbsp;&nbsp;
            <a role='button' style={{ cursor: 'pointer' }} title='Sil' onClick={() => deleteVideo(item.Id)}>
              <i className='icon-trash-2' style={{ fontSize: '1.2rem', color: 'red' }}></i>
            </a>
          </div>
        ),
      })),
    [videos]
  )

  return (
    <div className='container'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header'>
            <div className='row'>
              <div className='mb-3'>
                <span className='h4'>Eğitim Videoları</span>
                <Link to='/admin/HomeAndSiteOperation/video/watch-report'>
                  <button type='button' className='btn btn-info' style={{ float: 'right', marginRight: '10px' }}>
                    İzlenme Raporu
                  </button>
                </Link>
                <Link to='/admin/HomeAndSiteOperation/video-category/list'>
                  <button type='button' className='btn btn-secondary' style={{ float: 'right', marginRight: '10px' }}>
                    Kategorileri Yönet
                  </button>
                </Link>
                <Link to='/admin/HomeAndSiteOperation/video/add'>
                  <button type='button' className='btn btn-primary' style={{ float: 'right', marginRight: '10px' }}>
                    Video Ekle
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className='card-body'>
            <div className='table-responsive'>
              <Table columns={tableColumns} data={tableData} currentPage={0} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default componentWithContext(ListVideo)
